import styled from 'styled-components';

export const Div = styled.div`
  width: 80px;
  height: 80px;
  display: block;
`;
